import * as storage from '@inqool/uas-web-core/es/utils/storage';

export const PASSWORD_CHANGE_REQUIRED_HEADER = 'password-change-required';
export const PASSWORD_MIN_LENGTH_HEADER = 'password-min-length';
export const PASSWORD_CHANGE_REQUIRED_KEY = 'password-change-required';
export const PASSWORD_MIN_LENGTH_KEY = 'password-min-length';
export const PASSWORD_CHANGE_PATH = '/change-password';
export const DEFAULT_PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_CHANGE_EXTENSION = 'enforcepasswordchange';

export const getPasswordChangeState = (headers: Headers) => {
  const minLength = Number(headers.get(PASSWORD_MIN_LENGTH_HEADER));

  return {
    required: headers.get(PASSWORD_CHANGE_REQUIRED_HEADER) === 'true',
    minLength: isNaN(minLength) || minLength <= 0 ? DEFAULT_PASSWORD_MIN_LENGTH : minLength
  };
};

export const isPasswordChangeExtensionEnabled = (extensions: any = {}) => extensions[PASSWORD_CHANGE_EXTENSION] === 'true';

export const setPasswordChangeRequired = (minLength: number) => {
  storage.put(PASSWORD_CHANGE_REQUIRED_KEY, 'true');
  storage.put(PASSWORD_MIN_LENGTH_KEY, String(minLength));
};

export const clearPasswordChangeRequired = () => {
  storage.remove(PASSWORD_CHANGE_REQUIRED_KEY);
  storage.remove(PASSWORD_MIN_LENGTH_KEY);
};

export const isPasswordChangeRequired = () => storage.get(PASSWORD_CHANGE_REQUIRED_KEY) === 'true';

export const getPasswordMinLength = () => {
  const minLength = Number(storage.get(PASSWORD_MIN_LENGTH_KEY));

  return isNaN(minLength) || minLength <= 0 ? DEFAULT_PASSWORD_MIN_LENGTH : minLength;
};

export const shouldRedirectToPasswordChange = (
  passwordChangeRequired: boolean,
  pathname: string,
  passwordChangeExtensionEnabled: boolean
) => passwordChangeExtensionEnabled && passwordChangeRequired && pathname !== PASSWORD_CHANGE_PATH;



// WEBPACK FOOTER //
// ./src/modules/login/_passwordChange.ts